<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start" class="ion-hide-xl-up">
      <ion-button (click)="closed.emit()">{{ closeText }}</ion-button>
    </ion-buttons>
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="end" class="ion-hide-xl-down">
      <ion-button (click)="closed.emit()">{{ closeText }}</ion-button>
    </ion-buttons>
    <ion-buttons *ngIf="confirmText" slot="end" class="ion-hide-xl-up">
      <ion-button color="primary" [disabled]="isConfirming" (click)="confirmed.emit()">
        <ng-container *ngIf="isConfirming; else label">
          <ion-spinner name="circular" class="ion-margin-end"></ion-spinner>
        </ng-container>
        <ng-template #label> {{ confirmText }} </ng-template>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
